export default __webpack_public_path__ + "static/media/blob.e3950678.png";